import TweenLite from 'gsap'
/* eslint-disable no-unused-vars */
import ScrollToPlugin from 'gsap/ScrollToPlugin'
/* eslint-enable */

// Local files
import CONFIG from '../../config'

// Required for multi-pages website
import router from './Router'

// Pages
// Please sort the pages alphabetically
import Page404 from '../components/page-404'
import PageAbout from '../components/page-about'
import PageCase from '../components/page-case'
import PageHome from '../components/page-home'

// Components
// Please sort the componenets alphabetically
import AppGrid from '../components/app-grid'
import AppHeader from '../components/app-header'
import AppTransition from '../components/app-transition'

// Utils
import Gateway from '../utils/global/Gateway'
import Support from '../utils/global/Support'
import { getSafe } from '../utils/Object'

// Constants
import breakpoints from '../constants/breakpoints-values'

const support = new Support()

export default
{
    router,

    name: 'app',

    components:
    {
        // Pages
        // Please sort the pages alphabetically
        Page404,
        PageAbout,
        PageCase,
        PageHome,

        // Components
        // Please sort the componenets alphabetically
        AppGrid,
        AppHeader,
        AppTransition
    },

    data()
    {
        return {
            // Application
            CONFIG,
            componentId: null,
            content: null,
            _content: null,

            contentPage: null,
            _contentPage: null,

            case: null,

            urlHistory: [],

            homeLastSection: 0,

            // Bind with other components, don't change his label
            isTouch: support.touch,
            support,

            // Sizes
            width: 0,
            height: 0,
            breakpoints,

            // Mouse
            mouse:
            {
                x: 0,
                y: 0,
                fromCenter:
                {
                    x: 0,
                    y: 0,
                    ratio:
                    {
                        x: 0,
                        y: 0
                    }
                }
            },

            // Loading
            isFirstLoading: true,
            isTransitionActive: false,

            // Scroll
            pageHeight: 0,
            scrollTop: 0,
            smoothScroll: 0,
            scrollIsDisabled: false
        }
    },

    computed:
    {
        supportClasses()
        {
            return Object.keys(this.support).map(key =>
            {
                if (key === 'ie' && this.support[key]) return `is-${key} is-${key}-${this.support[key]}`
                if (this.support[key]) return `is-${key}`
                return false
            }).filter(c => c !== false).join(' ')
        }
    },

    watch:
    {
        $route: '_onRouteChange'
    },

    created()
    {
        // Variables
        this.$html = document.documentElement
        this.$body = document.body

        this.TRANSITION_MIN_DURATION = 0 // in ms

        this.time = {}
        this.time.delta = 16
        this.time.elapsed = 0
        this.time.current = new Date()
        this.time.start = this.time.current

        this.transition = {}
        this.transition.delta = 16
        this.transition.elapsed = 0
        this.transition.current = new Date()
        this.transition.start = this.transition.current

        // Events
        this.eventHub.$on('page:ready', this._onPageReady)
        // Window's events
        window.addEventListener('resize', this._onResize)
        // Mouse's events
        document.addEventListener('scroll', this._onScroll)
        document.addEventListener('mousemove', this._onMousemove)
        // Keyboard's event
        document.addEventListener('keydown', this._onKeydown)
        document.addEventListener('keyup', this._onKeyup)
        // Custom
        this.eventHub.$on('page:disable-scroll', this._onDisableScroll)
        this.eventHub.$on('page:enable-scroll', this._onEnableScroll)

        // Set currentUrl
        this.currentURL = this.$route.path

        // Run page
        this._onRouteChange(this.$route)
    },

    mounted()
    {
        this.$container = this.$el.querySelector('.js-container')
        this.$screen = this.$el.querySelector('.js-screen-size')

        this._onEnterFrame()
    },

    methods:
    {
        // EVENTS
        _onScroll()
        {
            this.scrollTop = window.scrollY || window.pageYOffset || document.body.scrollTop + (document.documentElement && document.documentElement.scrollTop || 0)
        },

        _onTouchMove(event)
        {
            if (this.scrollIsDisabled)
            {
                event.preventDefault()
            }
        },

        _onResize()
        {
            this.$nextTick(() =>
            {
                if (this.isTouch
                    && this.width === window.innerWidth)
                {
                    if (this.support.ios
                        && this.$screen)
                    {
                        this.width = this.$screen.offsetWidth
                        this.height = this.$screen.offsetHeight
                    }
                    else
                    {
                        this.width = window.innerWidth
                        this.height = window.innerHeight
                    }
                }
                else
                {
                    this.width = window.innerWidth
                    this.height = window.innerHeight

                    // Send event for components
                    this.eventHub.$emit('window:resize')
                }

                // if (this._headerColorArr)
                // {
                //     for (let i = 0; i < this._headerColorArr.length; i++)
                //     {
                //         this._headerColorArr[i].y = getAbsoluteBoundingRect(this.$headerColor[i]).top - 56 // top of menu header
                //         this._headerColorArr[i].height = this.$headerColor[i].offsetHeight
                //     }
                // }
            })
        },

        _onMousemove(event)
        {
            if (event.clientX && event.clientY)
            {
                this.mouse.x = event.clientX
                this.mouse.y = event.clientY

                this.mouse.fromCenter.x = this.mouse.x - this.width / 2
                this.mouse.fromCenter.y = this.mouse.y - this.height / 2

                this.mouse.fromCenter.ratio.x = this.mouse.fromCenter.x / (this.width / 2)
                this.mouse.fromCenter.ratio.y = this.mouse.fromCenter.y / (this.width / 2)
            }
        },

        _onKeydown(event)
        {
            this.eventHub.$emit('application:keydown', event)
        },

        _onKeyup(event)
        {
            this.eventHub.$emit('application:keyup', event)
        },

        _onPageReady()
        {
            if (this.content && this.contentPage)
            {
                // this.$headerColor = this.$el.querySelectorAll('.js-header-active-color')
                // this._headerColorArr = []
                //
                // for (let i = 0; i < this.$headerColor.length; i += 1)
                // {
                //     this._headerColorArr.push({
                //         y: 0,
                //         height: 0,
                //         activeColor: this.$headerColor[i].getAttribute('data-header-active-color')
                //     })
                // }

                this._onResize()
            }
        },

        _onSetPageHeight(height = 0)
        {
            this.pageHeight = height
        },

        _onEnterFrame()
        {
            window.requestAnimationFrame(this._onEnterFrame)

            const time = new Date()
            this.time.delta = time - this.time.current
            this.time.current = time
            this.time.elapsed = this.time.current - this.time.start

            if (this.time.delta > 60)
            {
                this.time.delta = 60
            }

            if (this.CONFIG.FAKE_SCROLL_ACTIVE
                && !this.isTouch)
            {
                this.smoothScroll += (this.scrollTop - this.smoothScroll) * 0.1
                this.smoothScroll = Math.round(this.smoothScroll * 100) / 100

                this.$container.style.transform = `translateY(${this.smoothScroll}px) translateZ(0)`
            }
            else
            {
                this.smoothScroll = this.scrollTop
            }

            // Send event for components
            this.eventHub.$emit('window:raf', this.time)
        },

        _changeHeaderColor(color)
        {
            this.headerColor = color
        },

        // ACTIONS
        _onDisableScroll()
        {
            this.$body.classList.add('u-overflow-h')
            this.$html.classList.add('u-overflow-h')

            this.scrollIsDisabled = true

            if (this.$smoothScrollContainer)
            {
                this.$smoothScrollContainer.classList.add('u-overflow-h')
            }

            this.eventHub.$emit('application:scroll-disabled')
        },

        _onEnableScroll()
        {
            this.$body.classList.remove('u-overflow-h')
            this.$html.classList.remove('u-overflow-h')
            this.$html.classList.add('u-overflow-xh')

            this.scrollIsDisabled = false

            if (this.$smoothScrollContainer)
            {
                this.$smoothScrollContainer.classList.remove('u-overflow-h')
            }

            this.eventHub.$emit('application:scroll-enabled')
        },

        scrollTo(value = 0, force = false)
        {
            if (force)
            {
                this.smoothScroll = value
                this.scrollTop = value
                window.scrollTo(0, value)
            }
            else
            {
                TweenLite.to(window, 1, { scrollTo: { y: value, autoKill: false }, autoKill: false, ease: 'Expo.easeInOut' })
            }
        },

        // TOGGLES
        // do something

        // ROUTES
        changePage(url = '/')
        {
            router.push(url)
        },

        _onRouteChange(to, from)
        {
            if (this.componentId !== to.meta.component
                || this.componentId === this.CONFIG.pages.case.name)
            {
                this.urlHistory.push(to)
                this.isTransitionActive = true

                this.transition.current = new Date()
                this.transition.start = this.transition.current

                this._onDisableScroll()

                this.eventHub.$emit('app-transition:change-color', to.meta.color)

                setTimeout(() =>
                {
                    this.scrollTo(0, true)
                }, this.TRANSITION_MIN_DURATION / 2)

                if (this.isFirstLoading)
                {
                    // Get all JSON
                    Promise.all(Object.keys(this.CONFIG.json).map(key =>
                        this.getJSONFromURL(this.CONFIG.json[key])
                    )).then(response =>
                    {
                        this._content = {}

                        Object.keys(this.CONFIG.json).forEach((key, index) =>
                        {
                            response.forEach((res, i) =>
                            {
                                if (index === i)
                                {
                                    this._content[key] = res
                                }
                            })
                        })

                        this.setLang()

                        this.content = this._content

                        this._getContentPage(to, from)
                    }).catch(() =>
                    {
                        // Get all JSON
                        Promise.all(Object.keys(this.CONFIG.json).map(key =>
                            this.getJSONFromURL(this.CONFIG.json[key])
                        )).then(response =>
                        {
                            this._content = {}

                            Object.keys(this.CONFIG.json).forEach((key, index) =>
                            {
                                response.forEach((res, i) =>
                                {
                                    if (index === i)
                                    {
                                        this._content[key] = res
                                    }
                                })
                            })

                            this.setLang()

                            this.content = this._content

                            this._getContentPage(to, from)
                        }).catch(error =>
                        {
                            this._content = {}
                            this.content = this._content

                            this.apiErrorActive = true

                            console.error(error)
                        })
                    })
                }
                else
                {
                    this._getContentPage(to, from)
                }
            }
        },

        _changeRoute(to, from)
        {
            this._updatePageMeta()

            this.$body.classList.remove(`is-${this.componentId}`)

            this.componentId = to.meta.component
            this.params = to.params

            this.currentURL = to.path

            this.$body.classList.add(`is-${this.componentId}`)

            this.isFirstLoading = false
            this.isTransitionActive = false

            if (this.componentId !== this.CONFIG.pages.home.name) this._onEnableScroll()

            this.eventHub.$emit('application:route-change', to, from)
        },

        // JSON
        getJSONFromURL(url)
        {
            return new Promise((resolve, reject) =>
            {
                Gateway.getInstance().send(
                    'GET',
                    url,
                    {},
                    response =>
                    {
                        resolve(response)
                    },
                    error =>
                    {
                        reject(error)
                    }
                )
            })
        },

        _getContentPage(to, from)
        {
            const apiURLs = this.$route.meta.api

            if (Object.keys(apiURLs).length > 0)
            {
                // Get all data from API
                Promise.all(Object.keys(apiURLs).map(key =>
                    this.getJSONFromURL(apiURLs[key], key)
                )).then(response =>
                {
                    this._contentPage = {}

                    Object.keys(apiURLs).forEach((key, index) =>
                    {
                        response.forEach((res, i) =>
                        {
                            if (index === i)
                            {
                                this._contentPage[key] = res
                            }
                        })
                    })

                    this.contentPage = this._contentPage

                    Object.keys(this.contentPage).forEach(key =>
                    {
                        if (key === 'options')
                        {
                            this.contentPage[key] = this.contentPage[key].entries[0]
                        }
                    })

                    this.transition.current = new Date()
                    const waintingTime = this.transition.current - this.transition.start < this.TRANSITION_MIN_DURATION ? this.TRANSITION_MIN_DURATION - (this.transition.current - this.transition.start) : 0

                    setTimeout(() =>
                    {
                        this.contentPage = this._contentPage

                        this._changeRoute(to, from)
                    }, waintingTime)
                })
            }
            else
            {
                this._contentPage = {}
                this.contentPage = this._contentPage

                if (to.name === this.CONFIG.pages.case.name)
                {
                    // Test if there are cases
                    if (getSafe(() => this.content.cases.entries)
                        && getSafe(() => to.params.slug))
                    {
                        let casee = null

                        for (let i = 0, l = this.content.cases.entries.length; i < l; i += 1)
                        {
                            const c = this.content.cases.entries[i]
                            if (c.title_slug === to.params.slug)
                            {
                                casee = c

                                if (i > 0)
                                {
                                    casee.previous_case = this.content.cases.entries[i - 1]
                                }

                                if (i < l - 1)
                                {
                                    casee.next_case = this.content.cases.entries[i + 1]
                                }
                            }
                        }

                        this.contentPage.case = casee
                    }
                }

                this._changeRoute(to, from)
            }
        },

        // SETTERS
        setLang()
        {
            // Set lang
            let lang = this.$route.params.lang

            // No lang
            if (typeof lang === 'undefined' || this._content.global.langsAvailable.indexOf(lang) === -1)
            {
                lang = navigator.language || navigator.userLanguage
                lang = lang.substring(0, 2).toLowerCase()

                if (this._content.global.langsAvailable.indexOf(lang) === -1) lang = 'en'
            }

            this.lang = lang
        },

        _updatePageMeta()
        {
            // Get SEO title, description, image, etc. from, in order :
            //  Default SEO (located into /static/json/seo.json)

            const metaTitle = this.content.seo.meta_title
            const metaDescription = this.content.seo.meta_description

            const facebookTitle = this.content.seo.facebook_title
            const facebookDescription = this.content.seo.facebook_description
            const facebookImage = this.content.seo.facebook_image
            const facebookImageAlt = this.content.seo.facebook_image_alt

            const twitterTitle = this.content.seo.twitter_title
            const twitterDescription = this.content.seo.twitter_description
            const twitterImage = this.content.seo.twitter_image

            const facebookAppID = this.content.seo.facebook_app_id
            //

            document.title = metaTitle

            const descriptionTag = document.querySelector('meta[name="description"]')
            // If there is a description tag & a meta description into config.js file
            descriptionTag.setAttribute('content', metaDescription)

            // Open Graph
            document.querySelector('meta[property="og:title"]').setAttribute('content', facebookTitle)

            document.querySelector('meta[property="og:site_name"]').setAttribute('content', facebookTitle)

            document.querySelector('meta[property="og:description"]').setAttribute('content', facebookDescription)

            document.querySelector('meta[property="og:image"]').setAttribute('content', facebookImage)

            document.querySelector('meta[property="og:image:alt"]').setAttribute('content', facebookImageAlt)

            document.querySelector('meta[property="og:url"]').setAttribute('content', window.location.href)

            document.querySelector('meta[property="fb:app_id"]').setAttribute('content', facebookAppID)

            // Twitter
            document.querySelector('meta[name="twitter:title"]').setAttribute('content', twitterTitle)

            document.querySelector('meta[name="twitter:description"]').setAttribute('content', twitterDescription)

            document.querySelector('meta[name="twitter:image"]').setAttribute('content', twitterImage)
        },

        // GETTERS
        getPageURLFromName(name)
        {
            let url = this.CONFIG.pages['404'].url

            if (this.CONFIG.pages[name])
            {
                url = this.CONFIG.pages[name].url
            }

            // Transform pages Object to Array
            const pagesKeyArray = Object.keys(this.CONFIG.pages)
            const pagesArray = []
            for (let i = 0, l = pagesKeyArray.length; i < l; i += 1)
            {
                pagesArray.push(this.CONFIG.pages[pagesKeyArray[i]])
            }

            // Filter if one page has the same meta.name than name parameter
            const page = pagesArray.filter(p => p.meta.name === name)

            // Ifo nly there is one match, return url
            if (page.length === 1)
            {
                return page[0].url.replace(':lang', this.lang)
            }

            return url.replace(':lang', this.lang)
        },

        getCaseURLFromSlug(slug)
        {
            return this.CONFIG.pages.case.url.replace(':slug', slug)
        }
    }
}



// WEBPACK FOOTER //
// ./src/scripts/application/script.js